import { companiesRepo } from '@/constants/providers';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { TaskKey } from '@/modules/Tasks/queries';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AttachUserCompanyModel } from '../types/attach-user-company-model';
import { CompanyKeys } from './keys';

export const useAttachUserCompany = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation<void, unknown, AttachUserCompanyModel>(
    (attachUserCompany) => companiesRepo.attachUserCompany(attachUserCompany),
    {
      onError: () => {
        toast.error(t('error.associate_user_company'));
      },
      onSuccess: () => {
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(UserKey.ALL);
      },
    },
  );
};
